import toBool from 'utils/toBool'
import { z } from 'zod'

const schema = (args) => {
	return z
		.object({
			providerId: z
				.string()
				.optional()
				.transform((val) => (val ? parseInt(val, 10) : undefined)),
			externalProvider: z
				.object({
					name: z.string().optional(),
					districtId: z
						.string()
						.optional()
						.transform((val) =>
							val ? parseInt(val, 10) : undefined
						),
				})
				.strict()
				.optional(),
			needsOptions: z
				.object({
					housing: z.boolean().optional().transform(toBool),
					transport: z.boolean().optional().transform(toBool),
				})
				.strict()
				.optional()
				.refine(
					(data) =>
						data?.housing !== undefined || !args?.requestEscort,
					{
						message: 'Required',
						path: ['housing'],
					}
				)
				.refine(
					(data) =>
						data?.transport !== undefined || !args?.requestEscort,
					{
						message: 'Required',
						path: ['transport'],
					}
				),
			notes: z.string().optional(),
			chargeAmount: z.number().optional(),
			injuredChargeAmount: z.number().optional(),
			administrativeObservation: z.string().optional(),
			outsideNetwork: z.boolean(),
		})
		.refine(
			(data) => data?.externalProvider?.name || !data?.outsideNetwork,
			{
				message: 'Required',
				path: ['providerName'],
			}
		)
		.refine(
			(data) =>
				data?.externalProvider?.districtId || !data?.outsideNetwork,
			{
				message: 'Required',
				path: ['districtId'],
			}
		)
		.refine((data) => data?.providerId || data?.outsideNetwork, {
			message: 'Required',
			path: ['providerId'],
		})
		.refine((data) => data?.externalProvider || !data?.outsideNetwork, {
			message: 'Required',
			path: ['providerName'],
		})
		.refine(
			(data) =>
				data?.chargeAmount !== undefined || !args?.requiresChargeAmount,
			{
				message: 'Required',
				path: ['chargeAmount'],
			}
		)
		.refine(
			(data) =>
				data?.injuredChargeAmount !== undefined ||
				!args?.requiresChargeAmount,
			{
				message: 'Required',
				path: ['injuredChargeAmount'],
			}
		)
}

export const StrictGenericManagerSchema = (args) => schema(args).strict()

export const GenericManagerSchema = (args) => schema(args)
